'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.employeeEvent', [])

.factory('employeeEventService', ['$http', '$q', function ($http, $q) {

    var service = {};

    service.GetEventsForEmployee = function () {
        return $http.get(environment.apiUrl + '/ID/Administration/Event/API/Employee')
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.GetEventsForMovementEmployee = function () {
        return $http.get(environment.apiUrl + '/ID/API/HR/Event/EmployeeMovement')
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;

}]);
